import { useContext } from 'react';

import InfoContext from '#src/contexts/info.tsx';

const useInfo = () => useContext(InfoContext)!;

export default useInfo;
